'use client';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { homePlusFooterLinkData } from '@/constants/footerLinks';
import {
  ButtonGroup,
  GlobalStyles,
  Link,
  Text,
} from '@/lib/mx-asurion-ui-react';
import Image from 'next/image';
import NotFoundImage from 'public/images/404.png';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  & > img {
    width: 671px;
    height: auto;
    max-width: 90vw;
  }
`;

const InnerWrapper = styled.div`
  & > * {
    text-align: center;
    margin-bottom: 1.5rem;
  }
`;

export default function NotFound() {
  return (
    <>
      <Header />
      <section>
        <GlobalStyles />
        <InnerWrapper className="mt-8">
          <Text as="h1" size={7} weight="feather">
            This page is missing
          </Text>
          <Text as="p">
            It may have been moved or deleted.
            <br />
            But don&rsquo;t worry, we can fix almost anything.
          </Text>
          <ButtonGroup alignment="center">
            <Link
              href="https://www.asurion.com"
              variant="button"
              rel="noopener noreferrer"
            >
              Take me to Asurion.com
            </Link>
          </ButtonGroup>
          <ImageWrapper>
            <Image src={NotFoundImage} alt="" />
          </ImageWrapper>
        </InnerWrapper>
      </section>
      <Footer linkData={homePlusFooterLinkData} />
    </>
  );
}
